<template>
  <div>
    <v-btn
      class="close-btn pa-0"
      @click="$emit('click', false)"
      absolute
      depressed
      max-width="40px"
      min-width="40px"
    >
    </v-btn
    >
    <v-row class="no-gutters under-sec-flat d-flex justify-end align-center">
      <v-toolbar
        color="primary"
        dark
        class="pa-1 d-flex justify-end align-center"
        max-height="50px"
      >
        <div>
          <v-btn color="#FFFFFF" class="no-uppercase" rounded small dark outlined :loading="exportStatus" :disabled="sDataShow.length == 0" @click="onExportar()">
            <v-icon size="13px" left>mdi-export</v-icon>
            Exportar
          </v-btn>
        </div>
      </v-toolbar>
    </v-row>
    <div class="cont-total-b">
      <div v-if="sDataShow.length > 0" v-html="sDataShow" class="ma-3"></div>
      <!-- <v-progress-circular v-else  indeterminate color="primary"></v-progress-circular> -->
      <div
        v-if="!sDataShow.length > 0"
        class="mx-auto d-flex justify-center align-center pa-2 tit-cargando"
      >
        <fulfilling-bouncing-circle-spinner
          :animation-duration="4000"
          :size="40"
          color="#0E69B0"
        />
        <h2 class="ma-0 ml-4">Cargando...</h2>
      </div>
      <div v-if="sUbicacion.length > 0" width="100%" id="printPage">
        <MapaView
          v-if="sUbicacion.length > 0"
          :lat="sUbicacion.split(',')[0]"
          :lng="sUbicacion.split(',')[1]"
          :dimencion="{ ancho: '100%', alto: '350px' }"
          :isDraggable="false"
        >
        </MapaView>
      </div>
    </div>
  </div>
</template>

<script>
import axiosServices from "@/services/axiosServices.js";
import MapaView from "@/components/Mapas/mapLocalizar.vue";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";

export default {
  name: "MostrarImagen",
  components: {
    MapaView,
    FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      campos: "",
      sDataShow: "",
      exportStatus: false,
      sUbicacion: "", // Debe llegar lat,lng
    };
  },
  async mounted() {
    await this.onGetInfo();
    //Se agrega estilo para resposive del componente Logo solo al momento de visualizar el VUE y no afectar el formato original que viene de PDFComponents
    //ya que se debe mantener para garantizar el exportado de PDF.
    document
      .getElementById("img-logo-detalle")
      .classList.add("responsive-logo-detalle");
  },
  methods: {
    async onGetInfo() {
      const axiosInfo = await axiosServices.getConfiguration( `/build_correo/verdetalle/${this.$route.params.sCasoCorreo}/${this.$route.params.nIdCaso}`, true, "", "ACF9413C0F77A6268700C8D5DD74E9286DA7667C51A43FADB6A62673B4ABED95");
      if (axiosInfo.sStatus === "success") {
        this.sDataShow = axiosInfo.aData.html;
        this.sUbicacion = axiosInfo.aData.LatLng;
      }
    },
    cardAction(val) {
      this.ampliar = true;
      this.ftampliada = val;
    },
    async onExportar() {
      this.exportStatus = true;

      const MapimgBase64 = await this.onExportMapa();
      let oBody = {
        MapimgBase64: "",
      };
      if (MapimgBase64 !== null) {
        oBody.MapimgBase64 = MapimgBase64;
      }

      const axiosFile = await axiosServices.postConfiguration(
        `/build_correo/pdfverdetalle/${this.$route.params.sCasoCorreo}/${this.$route.params.nIdCaso}`,
        oBody,
        true,
        "",
        "ACF9413C0F77A6268700C8D5DD74E9286DA7667C51A43FADB6A62673B4ABED95"
      );

      const sFile = await this.urltoFile(
        "data:text/pdf;base64," + axiosFile.aData.sFile,
        axiosFile.aData.sNombreArchivo,
        "text/pdf"
      );
      const url = window.URL.createObjectURL(sFile);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", axiosFile.aData.sNombreArchivo); //or any other extension
      document.body.appendChild(link);
      link.click();

      //this.$analytics.logEvent('DetalleCorreo-'+this.$route.params.sCasoCorreo+'', { exportarDetalle:1}) //Analitics

      this.exportStatus = false;
    },
    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
    async onExportMapa() {
      // como solo hay un elemento con id printPage no recorro nada
      const elements = document.querySelector("#printPage");
      if (elements !== null) {
        const imagen = await html2canvas(elements, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
        });
        return imagen.toDataURL("image/png", 1.0);
      }

      return null;
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
};
</script>

<style lang="scss" scoped>
.ClassImagen {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-content: center;
}

.cont-total-b {
  width: 55%;
  height: auto;
  margin: 0 auto;
  color: #000000;
  border: solid 2px #dedede;
  padding: 5px;
  @media screen and (max-width: 1200px) {
    width: 75%;
    padding: 5px;
  }
  @media screen and (max-width: 860px) {
    width: 100%;
    border: none;
    padding: 0px;
  }
}
</style>